<template>
    <el-dialog v-model="dialogShow" width="400px" center @close="closeEvent" modal-class="dialog-new-model">
        <div class="login-container">
            <div class="login-title">HELLO,欢迎登陆
                <span class="activeColor">开悟作文</span>
            </div>
            <div class="login-tabs">
                <div :class="tabActive=='login'?'active':''" @click="tabClick('login')">账号密码登陆</div>
                <div :class="tabActive=='codeLogin'?'active':''" @click="tabClick('codeLogin')">验证码登陆</div>
            </div>
            <div class="login-form">
                <el-form ref="loginRef" :model="formData" :rules="formRules">
                    <template v-if="tabActive=='login'">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item prop="phone">
                                    <el-input v-model="formData.phone" placeholder="请输入手机号/账号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <el-form-item prop="password">
                                    <el-input v-model="formData.password" placeholder="请输入密码" type="password" show-password></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-button color="#ef8b25" plain @click="passShow=true">忘记密码</el-button>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-if="tabActive=='codeLogin'">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item prop="codephone">
                                    <el-input v-model="formData.codephone" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="5">
                            <el-col :span="16">
                                <el-form-item prop="imgcode">
                                    <el-input v-model="formData.imgcode" placeholder="请输入图形验证码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <div class="loginCodeImg" v-if="loginCodeImg" @click="getImgCode">
                                    <img :src="loginCodeImg" />
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="5">
                            <el-col :span="16">
                                <el-form-item prop="code">
                                    <el-input v-model="formData.code" placeholder="请输入验证码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-button color="#ef8b25" plain @click="getCode">{{codeTime?`${codeTime}秒重新获取`:'获取验证码'}}</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-form>
            </div>
            <div style="margin:0 0 20px;">
                <el-checkbox v-model="formData.flag">
                    我已阅读并同意
                    <span class="activeColor" @click.stop="policyShow=true">《用户协议》</span>和
                    <span class="activeColor" @click.stop="privacyShow=true">《隐私政策》</span>
                </el-checkbox>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="loginEvent">确认登陆</el-button>
            </div>
            <div>
                <el-divider>
                    <span style="font-size:12px;">还没账号？
                        <span class="activeColor" style="cursor:pointer;" @click="registerShow=true">立即注册</span>
                    </span>
                </el-divider>
            </div>
        </div>

        <policy-dialog :popupShow="policyShow" v-if="policyShow" @close="policyShow=false"></policy-dialog>
        <privacy-dialog :popupShow="privacyShow" v-if="privacyShow" @close="privacyShow=false"></privacy-dialog>
        <register-dialog :popupShow="registerShow" v-if="registerShow" @close="registerShow=false" @registerClose="registerClose"></register-dialog>
        <pass-dialog :popupShow="passShow" v-if="passShow" @close="passShow=false"></pass-dialog>
        <phone-dialog :popupShow="phoneShow" v-if="phoneShow" @close="phoneClose"></phone-dialog>
        <student-dialog :popupShow="studentShow" v-if="studentShow" @close="studentClose"></student-dialog>
    </el-dialog>
</template>
<script lang="ts" setup>
import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import registerDialog from "./registerDialog.vue"
import passDialog from "./passDialog.vue"
import phoneDialog from "./phoneDialog.vue"
import studentDialog from "./studentDialog.vue"
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { login, getUserInfo, sendCode, getCaptcha } from "@/api/common.js"
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const tabActive = ref('login')
const loginRef = ref()
const formData = ref({
    phone: '',
    code: '',
    password: '',
    flag: false,
    codephone: '',
    imgcode: ''
})
const policyShow = ref(false)
const privacyShow = ref(false)
const registerShow = ref(false)
const passShow = ref(false)
const phoneShow = ref(false)
const studentShow = ref(false)
const codeTime = ref(0)
let codeTimer = null
const userInfo = {}
const loginCodeImg = ref()
let nowUuid = ''
const emitList = defineEmits(['close'])
const store = useStore();
const formRules = {
    phone: [
        {
            message: '请输入手机号/账号',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入手机号/账号"))
                }
                callback()
            }
        }
    ],
    codephone: [
        {
            message: '请输入手机号',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入手机号"))
                }
                callback()
            }
        }
    ],
    password: [
        {
            message: '请输入密码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入密码"))
                }
                callback()
            }
        }
    ],
    code: [
        {
            message: '请输入验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入验证码"))
                }
                callback()
            }
        }
    ],
    imgcode: [
        {
            message: '请输入图形验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入图形验证码"))
                }
                callback()
            }
        }
    ],
}

function phoneClose() {
    if (userInfo.firstLoginByPhone) {
        studentShow.value = true
        phoneShow.value = false;
    } else {
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            emitList('close')
            router.go(0)
        })
    }
}

function studentClose() {
    emitList('close')
    router.go(0)
}

function tabClick(type) {
    if (type == tabActive.value) return
    tabActive.value = type;
    loginRef.value.clearValidate()
    if (type == 'codeLogin') {
        getImgCode()
    }
}

function loginEvent() {
    let validArr = ['phone', 'password']
    if (tabActive.value == 'codeLogin') {
        validArr = ['codephone', 'code', 'imgcode']
    }
    loginRef.value.validateField(validArr, valid => {
        if (valid) {
            if (!formData.value.flag) {
                return ElMessage.warning('请先阅读用户协议和隐私政策');
            }
            let params = {}
            if (tabActive.value == 'login') {
                params = {
                    phone: formData.value.phone,
                    password: formData.value.password,
                    type: 'student'
                }
            } else if (tabActive.value == 'codeLogin') {
                params = {
                    phone: formData.value.codephone,
                    code: formData.value.code,
                    type: 'student'
                }
            }
            console.log(params)
            login(params).then(res => {
                console.log(res)
                sessionStorage.setItem('token', res.data.jwt)
                getUser()
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function registerClose() {
    registerShow.value = false
    getUser()
}

function getUser() {
    getUserInfo().then(res => {
        store.dispatch('setLogin', res.data);
        store.dispatch('setGradeTerm', {
            grade: res.data.grade || '三年级',
            term: res.data.term || '上学期'
        })
        jumpEvent(res)
    })
}

function jumpEvent(res) {
    if (res.data.firstLoginByPassword) {
        phoneShow.value = true
    } else if (res.data.firstLoginByPhone) {
        studentShow.value = true
    } else {
        emitList('close')
        router.go(0)
    }
}

function closeEvent() {
    emitList('close')
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        loginRef.value.validateField(['codephone', 'imgcode'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.codephone,
                    type: '01',
                    uuid: nowUuid
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}
function getImgCode() {
    const randomNum = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;
    const uuid = `${randomNum}-${new Date().getTime()}`
    getCaptcha({
        uuid: uuid
    }).then(res => {
        loginCodeImg.value = 'data:image/png;base64,' + res.data;
        nowUuid = uuid
    })
}
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";

.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
    .loginCodeImg {
        width: 102px;
        height: 32px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>

<style lang="scss">
.dialog-new-model {
    .el-dialog {
        background: url("@/assets/img/bg2.jpg") no-repeat;
        background-size: 100% 100%;
        .el-divider__text {
            background-color: transparent;
        }
    }
}
</style>


